// args are flatProducts

const perserveOnVariantChange = (oldProduct, newProduct) => {
  return {
    ...newProduct,
    quantity: oldProduct.quantity,
  };
};

export default perserveOnVariantChange;
